const config: Record<string, any> = Object.assign(
    { siteName: "NuORDER by Lightspeed" },
    process.env.CONFIG || {},
    (window as any).NUCONFIG || {},
);

((window || {}) as any).nuConfig = config;

export default config;

export const getConfig = () => config;
